import { ANALYTICS_CONFIG } from '../constants/config';

const SCRIPT_ID = 'neoprof-umami';

export const initAnalytics = () => {
  const { websiteId, scriptSrc, domains } = ANALYTICS_CONFIG;
  if (!websiteId || document.getElementById(SCRIPT_ID)) return;

  const script = document.createElement('script');
  script.id = SCRIPT_ID;
  script.defer = true;
  script.src = scriptSrc;
  script.dataset.websiteId = websiteId;
  script.dataset.domains = domains;
  document.head.appendChild(script);
};

export const trackEvent = (name, data) => {
  try {
    window.umami?.track(name, data);
  } catch {
    // Tracking must never interrupt the action that produced the event.
  }
};
